import ApiService from "./ApiService"

export default {
    comapreWeek(context) {
        
        let params = new URLSearchParams();
        if(context.year)
            params.append('year', context.year);
        if(context.compareYear)
            params.append('compareYear', context.compareYear);
        let qs = params.toString();

        return ApiService().get(`api/week-statistics/${context.week}/${context.compareWeek}?${qs}`);
    },
    comapreMonth(context) {
        let params = new URLSearchParams();
        if(context.year)
            params.append('year', context.year);
        if(context.compareYear)
            params.append('compareYear', context.compareYear);
        let qs = params.toString();

        return ApiService().get(`api/month-statistics/${context.month}/${context.compareMonth}?${qs}`);
    },
    getWeeklyStatistics(context) {
        return ApiService().get(`api/day-statistics/${context.start}/${context.end}/${context.startCompare}/${context.endCompare}`);
    },
    getProjectStats() {
        return ApiService().get(`api/project-statistics`);
    },
}